import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectUpdateDtoSchema = z.object({
  name: z.string().max(255).nullable().optional().describe('The name of the project'),
  enableFp64: z
    .boolean()
    .optional()
    .describe('Enable fp64 (Double floating point precision) for the project'),
  enablePbr: z
    .boolean()
    .optional()
    .describe('Enable PBR (Physically based rendering) for the project'),
  showEdges: z.boolean().optional().describe('Show edges for the project'),
  showBoundingBox: z.boolean().optional().describe('Show bounding box for the project'),
  cameraFarDistance: z.number().int().optional().describe('Camera far distance for the project'),
  cameraFarDisabled: z
    .boolean()
    .optional()
    .describe('Disable the camera far clipping plane for the project'),
});

@UseSchema(projectUpdateDtoSchema)
export class ProjectUpdateDto {}
export interface ProjectUpdateDto extends z.input<typeof projectUpdateDtoSchema> {}
